import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Angula4xAutoCompleteComponent } from './angula4x-auto-complete/angula4x-auto-complete.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [Angula4xAutoCompleteComponent],
  exports:[Angula4xAutoCompleteComponent]
})
export class Angular4xAutoCompleteModule { }
